<!--Header responsible for arrows-->
<app-generic-header
  [goBack]="saveChangesButton ? saveButton.bind(this) : exitButton.bind(this)"
  [variant]="
  pageParameters.firstSetup
    ? 'empty'
    : (saveChangesButton ? 'save' : 'back')
">
</app-generic-header>

<ion-content class="ion-padding">

  <div class="centralized">


    <div class="page-image">
      <ion-icon [src]="pageParameters.logoURL"></ion-icon>
    </div>

    <div class="page-name">
      {{ pageParameters.text }}
    </div>
  
    <div class="modalButtons">
      <div id="otherOptionInput">
        <ion-item>
          <ion-input lines="none" type="text" [(ngModel)] = "otherOptionInput" placeholder={{pageParameters.valuePlaceHolder}} (input)="showSaveButton()"></ion-input>
        </ion-item>
  
        <div class="charsLeftContainer">
          <span class="charsLeft{{getCharStatus()}}">{{getCharsLeft()}} {{"left" | translate}}</span>
        </div>
      </div>
    </div>

    <div class="next-buttons">
      <ion-button fill="outline" mode= "md" class="back-button" (click)="backButton()" size="small" value="back"  shape="round">{{ 'backSurvey' | translate }}</ion-button>

      <ion-button color="secondary" mode= "md" (click)="nextButton()" size="small" value="next" shape="round">{{ 'nextSurvey' | translate }}</ion-button>
    </div>
    
  </div>
</ion-content>